<template>
  <div>
    <div class="subtab" v-if="subtabs">
      <div
        v-for="(item, index) in subtabs"
        :key="index"
        class="subtab-item"
        :class="{ active : item.category === categoryNow }"
        @click="changeSubTab(item.category)"
      >{{item.name}}</div>
    </div>
    <m-textArea
      class="data-list"
      :class="{ hasSubtab : subtabs }"
      ref="dataList"
    >
      <div class="pic-list">
        <div
          v-for="(item, index) in datalist"
          :key="index"
          class="pic-item"
          @click="$emit('showpic', item)"
        >
          <img :src="preview(item)">
        </div>
      </div>
      <Pagination
        :num="pageNow"
        :pages="pages"
        @change="chagenPage"
      ></Pagination>
    </m-textArea>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

import TextArea from "@/components/TextArea";
import VideoList from './VideoList';
import Pagination from "@/components/Pagination";

export default {
  components: {
    "m-textArea": TextArea,
    Pagination,
    VideoList
  },
  props: {
    subtabs: Array,
    category: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      categoryNow: ""
    }
  },
  computed: {
    ...mapState(["extension"]),
    datalist() {
      return this.extension[this.pageNow]
    },
    pageNow() {
      return this.extension.number
    },
    pages() {
      return this.extension.total_pages;
    }
  },
  mounted() {
    this.getPageData({
      category: this.category
    });
  },
  methods: {
    ...mapActions(["getExtension"]),
    getPageData({page_num = 0, category}) {
      const param = {
        category,
        page_num
      };
      this.getExtension(param);
      this.categoryNow = category;
    },
    chagenPage(num) {
      this.getPageData({
        page_num: num,
        category: this.categoryNow
      });
      this.$refs.dataList.scroll();
    },
    changeSubTab(category) {
      this.getPageData({
        category
      });
      this.$refs.dataList.scroll();
    },
    preview(pic) {
      const host = location.hostname === "shadow.caa.edu.cn"
        ? ""
        : "http://shadow.caa.edu.cn";
      
      if (pic.preview) {
        return host + pic.preview;
      }

      if (/(shadowresou)/.test(pic.path)) {
        var n = pic.path.lastIndexOf("/");
        var str1 = pic.path.slice(0, n);
        var str2 = "/PreviewPic/Pre" + pic.path.slice(n+1);
        return host + str1 + str2;
      } else {
        return host + pic.path;
      }
    }
  }
}
</script>

<style lang="scss">
@import "../../assets/base";
.pic-list {
  margin: 0 auto;
  margin-bottom: 1rem;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  box-sizing: border-box;

  .pic-item {
    width: 30vw;
    height: 30vw;
    margin: 2px;
    line-height: 30vw;
    background-color: $text-picinfo;
    text-align: center;
    box-sizing: border-box;

    & img {
      display: inline-block;
      max-width: 100%;
      max-height: 100%;
      vertical-align: middle;
    }
  }
}
</style>


